import { GoogleOAuthProvider } from '@react-oauth/google';
import { useEffect, useState } from 'react';
import Login, { fetchBackend } from './auth';
import { CalendarView } from './CalendarView';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";

function App() {

  const [isLogged, setIsLogged] = useState(false);

  useEffect(() => {

    const fetchOnce = async () => {
      const authResp = await fetchBackend("/check-auth", {method: "GET"})
      setIsLogged( authResp.ok );
    }

    fetchOnce()
  }, []);


  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
      { isLogged
        ? <CalendarView/>
        : <Login setIsLogged={setIsLogged}/>}
    </GoogleOAuthProvider>
  )
}

export default App;